import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MmzSelection } from 'site-modules/shared/components/make-model-zip-selection/make-model-zip-selection';
import { generateTrackingIds, LINKS_MAP, DEFAULT_PUB_STATES } from 'site-modules/shared/utils/make-model-zip';
import './make-model-zip-dropdown.scss';

export class MakeModelZipDropdown extends Component {
  static propTypes = {
    className: PropTypes.string,
    hasZipInput: PropTypes.bool,
    pubStates: PropTypes.arrayOf(PropTypes.string),
    tracking: PropTypes.shape({}),
    hasYearDropdown: PropTypes.bool,
    linkType: PropTypes.string,
    rel: PropTypes.string,
    onSubmit: PropTypes.func,
    isGoBtnDisabled: PropTypes.bool,
    dataTrackingParent: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    hasZipInput: false,
    pubStates: DEFAULT_PUB_STATES,
    tracking: generateTrackingIds(''),
    hasYearDropdown: false,
    linkType: LINKS_MAP.CORE_PAGE,
    rel: '',
    onSubmit: null,
    isGoBtnDisabled: false,
    dataTrackingParent: undefined,
  };

  state = {
    make: null,
    model: null,
    year: null,
  };

  setMake = make =>
    this.setState({
      make,
      model: null,
      year: null,
    });

  setModel = model => this.setState({ model, year: null });

  setYear = year => this.setState({ year });

  render() {
    const {
      className,
      hasYearDropdown,
      hasZipInput,
      pubStates,
      tracking,
      linkType,
      rel,
      onSubmit,
      isGoBtnDisabled,
      dataTrackingParent,
    } = this.props;
    const { make, model, year } = this.state;

    return (
      <MmzSelection
        className={className}
        hasYearDropdown={hasYearDropdown}
        hasZipInput={hasZipInput}
        pubStates={pubStates}
        tracking={tracking}
        make={make}
        model={model}
        year={year}
        linkType={linkType === LINKS_MAP.CORE_PAGE ? LINKS_MAP.REVIEW_PAGE : linkType}
        rel={rel}
        setMake={this.setMake}
        setModel={this.setModel}
        setYear={this.setYear}
        onSubmit={onSubmit}
        isGoBtnDisabled={isGoBtnDisabled}
        dataTrackingParent={dataTrackingParent}
      />
    );
  }
}
